import { Outlet } from "react-router-dom";
import React from "react";
import LayoutWrapper from "@/components/layoutWrapper";

const Layout: React.FC = () => {
  return (
    <LayoutWrapper>
      <Outlet />
    </LayoutWrapper>
  );
};

export default Layout;
